/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Draft_Reset_TitleInputs */

const vi_einvoice_draft_reset_title = /** @type {(inputs: Einvoice_Draft_Reset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bỏ chỉnh sửa và tạo lại nháp?`)
};

/**

* @param {Einvoice_Draft_Reset_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_draft_reset_title = /** @type {((inputs?: Einvoice_Draft_Reset_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Draft_Reset_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_draft_reset_title(inputs)
});